export class AssignmentActivityCategory {
    ID: number;
    Description: string;
}

export class AssignmentActivity {
    ActivityID: string;
    Level: number;
    Lesson: number;
    Sequence: number;
    SubSequence: number;
    Title: string;
    Description: string;
    MinTime: number;
    MaxTime: number;
    ImageName: string;
    Summary: string;
    Order: number;
}

export class AssignmentActivityUnit {
    ActivityID: string;
    Number: number;
    Description: string;
}